exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-grid{\r\n  padding:5px;\r\n}\r\n\r\n.dashboard-grid md-grid-tile {\r\n  padding: 5px;\r\n}\r\n\r\n.dashboard-grid md-grid-list {\r\n  margin: 8px;\r\n}\r\n\r\napp-dynamic-components {\r\n  width: 100%;\r\n  height:100%;\r\n}\r\n\r\n.froala-container {\r\n  max-height: 250px;\r\n}\r\n.froala-container .fr-separator.fr-hs {\r\n  clear: none;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/dashboard/dashboard.component.css
// module id = ../../../../../src/app/components/dashboard/dashboard.component.css
// module chunks = main